import React from 'react';

export default function PhotosTab() {
  return (
    <div className='flex-center text-center w100'>
      <a
        target='_blank'
        rel='noopener noreferrer'
        href='https://forms.zohopublic.com/phius/form/UploadImagestoProject/formperma/j23GEUc9it099122Kcx7gpTGWt15gFR1Xq3hV398nag'
        className='my-1 cta-button remove-text-decoration'
      >
        UPLOAD PHOTOS
      </a>
    </div>
  );
}
